export default {
  data () {
    return {
      postcodeRegex: new RegExp('^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$'),
      // eslint-disable-next-line no-useless-escape
      fullNameRegex: "^[\-A-Za-z\u00C0-\u017F\']{1,}(?: [\-A-Za-z\u00C0-\u017F\']{1,})+$",
      phoneRegex: /^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)[1-9]\d(\s)?\d{1}(\s)?\d{1}(\s)?\d{2}(\s)?\d{1}(\s)?\d{3}$/g,
      emailRegex: /^[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/g,
      // eslint-disable-next-line no-useless-escape
      businessNameRegex: /^[A-Za-z0-9()_\-\'\’\.\&\s]*$/g
    }
  }
}
